// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7u-0";
export var startPickingButton = "_7u-1";